























import Vue from 'vue';
import {
  mapActions,
  mapGetters,
} from 'vuex';
import { IUserCategoryObject } from '../../../../shared/types';

import api from '../../api';
import CategoryCards from '../../components/ui/category-cards/category-cards.vue';

export default Vue.extend({
  name: 'Categories',

  components: {
    CategoryCards,
  },

  data: () => ({
    categories: [] as IUserCategoryObject[],
  }),

  async created() {
    this.handlePageLoad({
      name: this.$route.name,
    });
    this.requiresLogin();

    this.refresh();
  },

  computed: {
    ...mapGetters('user', [
      'getUser',
    ]),
  },

  methods: {
    ...mapActions('navigation', [
      'handlePageLoad',
      'requiresLogin',
    ]),

    async add() {
      await api.category.create();

      this.refresh();
    },

    async refresh() {
      this.categories = await api.category.getUserCategories(this.getUser.id);
    },
  },
});
